import { CLEAR_STRUCT_TOP } from "../../../enums/Request/leader.requests.types";

export const clearStructureTopAction = () => {
    return {
        type: CLEAR_STRUCT_TOP,
    };
};